import React from "react";
import './experience.css'
import useReveal from "../../hooks/useReveal";

const skills = [
    { key: "languages", values: ["Python", "SQL", "JavaScript"] },
    { key: "backend", values: ["FastAPI", "Django", "Flask"] },
    { key: "data_lakehouse", values: ["ClickHouse", "Trino", "Apache Iceberg", "BigQuery", "PostgreSQL", "MongoDB", "Parquet"] },
    { key: "cloud_infra", values: ["GCP", "AWS", "Kubernetes", "Terraform", "Ansible", "Docker"] },
    { key: "orchestration", values: ["Argo Workflows", "Kafka", "Redis"] },
    { key: "ai_ml", values: ["LLM fine-tuning", "GPU infrastructure", "TensorFlow", "Vector Search", "Elasticsearch"] },
];

const Experience = () => {
    const ref = useReveal();
    return (
        <section id="experience">
            <h5>$ cat skills.json</h5>
            <h2>My Stack</h2>
            <div className="container reveal" ref={ref}>
                <div className="skilljson term-window">
                    <div className="term-titlebar">
                        <span className="term-dot red"></span>
                        <span className="term-dot yellow"></span>
                        <span className="term-dot green"></span>
                        <span className="term-path">~/skills.json</span>
                    </div>
                    <div className="skilljson__body mono">
                        <p className="skilljson__cmd"><span className="txt-green">$</span> cat skills.json</p>
                        <div className="skilljson__code">
                            <div className="sj-line"><span className="sj-punc">{"{"}</span></div>
                            {skills.map((entry, i) => (
                                <div className="sj-line sj-indent" key={entry.key}>
                                    <span className="sj-key">"{entry.key}"</span>
                                    <span className="sj-punc">: [</span>
                                    {entry.values.map((v, j) => (
                                        <React.Fragment key={v}>
                                            <span className="sj-str">"{v}"</span>
                                            {j < entry.values.length - 1 && <span className="sj-punc">, </span>}
                                        </React.Fragment>
                                    ))}
                                    <span className="sj-punc">]{i < skills.length - 1 ? "," : ""}</span>
                                </div>
                            ))}
                            <div className="sj-line"><span className="sj-punc">{"}"}</span></div>
                        </div>
                        <p className="skilljson__cmd"><span className="txt-green">$</span> <span className="skilljson__cursor"></span></p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Experience
